<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section bg-white']" :id="'block-' + block.id">
    <div class="container">
        <div :class="['columns is-variable is-6', block.alignment]">
            <aside v-if="!block.is_team && block.excerpts && block.excerpts.excerpt" class="column is-4 aside has-text-centered">
                <div :class="['aside__inner', {'no-portrait': !block.portrait}]">
                    <figure :style="'padding-top: ' + block.portrait.ratio + '%;'" v-if="block.portrait">
                        <img class="is-block primary-portrait" :src="block.portrait.url" :alt="block.portrait.title" />
                        <img class="is-block alt-portrait" v-if="block.alt_portrait" :src="block.alt_portrait.url" :alt="block.alt_portrait.title" />
                    </figure>
                    <p class="linkedin-url" v-if="block.linkedin">
                        <a :href="block.linkedin" target="_blank">View Linkedin Profile</a>
                    </p>
                    <p><span class="is-circle"><i class="fas fa-quote-left"></i></span></p>
                    <blockquote class="excerpt" v-html="block.excerpts.excerpt"></blockquote>
                    <p class="creditor-info" v-if="block.excerpts.credit">
                        <strong>{{block.excerpts.credit}}</strong><template v-if="block.excerpts.creditor_title">, <span>{{block.excerpts.creditor_title}}</span></template>
                    </p>
                </div>
            </aside>
            <aside v-else-if="block.is_team" class="column is-4 aside has-text-centered">
                <div :class="['aside__inner', {'no-portrait': !block.portrait}]">
                    <figure :style="'padding-top: ' + block.portrait.ratio + '%;'" v-if="block.portrait">
                        <img class="is-block primary-portrait" :src="block.portrait.url" :alt="block.portrait.title" />
                        <img class="is-block alt-portrait" v-if="block.alt_portrait" :src="block.alt_portrait.url" :alt="block.alt_portrait.title" />
                    </figure>
                    <p class="title is-3">{{ block.fullname }}</p>
                    <p class="subtitle is-4">{{ block.role }}</p>
                    <p class="linkedin-url" v-if="block.linkedin">
                        <a :href="block.linkedin" target="_blank">View Linkedin Profile</a>
                    </p>
                    <template v-if="block.excerpts && block.excerpts.excerpt">
                        <p><span class="is-circle"><i class="fas fa-quote-left"></i></span></p>
                        <blockquote class="excerpt" v-html="block.excerpts.excerpt"></blockquote>
                        <p class="creditor-info" v-if="block.excerpts.credit">
                            <strong>{{block.excerpts.credit}}</strong><template v-if="block.excerpts.creditor_title">, <span>{{block.excerpts.creditor_title}}</span></template>
                        </p>
                    </template>
                </div>
            </aside>
            <div :class="[`article-content column is-${block.excerpt_hidden ? '12' : '8'}`, {'is-offset-4': !block.is_team && (!block.excerpts || !block.excerpts.excerpt) && !block.excerpt_hidden}]">
                <h1 v-if="block.title" class="title is-2">{{block.title}}</h1>
                <article ref="content" class="content" v-html="block.content"></article>
                <div class="content cta" v-if="block.cta">
                    <CTALink :link_data="block.cta" />
                </div>
                <div v-if="!block.is_team && !block.no_share" class="social-media-sharing columns is-variable is-8 is-vertical-centred">
                    <div class="column">Share This Story, Choose Your Platform!</div>
                    <div :class="['column', {'is-half': !block.linkedin}]">
                        <div class="addthis_inline_share_toolbox"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name        :   'NewsContentBlock',
    mixins      :   [ BlockCommons ],
    mounted()
    {
        this.$nextTick().then(() => {
            if (typeof(addthis) != 'undefined' && addthis.layers.refresh) {
                addthis.layers.refresh();
            }

            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        });
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/NewsContentBlock.vue